import '../sass/app.scss';

import 'dom4';
import domready from 'domready';
import LeaveMessageModule from './components/leave-message-module'
import GlobalHeader from './components/global-header'
import PageHeroModule from './components/page-hero-module'
import MobileNav from './components/mobile-nav'
import TreatmentsModule from './components/treatments-module'
import VideosModule from './components/videos-module'
import EMFACECounters from './components/emface-counters'
import TeamMembersModule from './components/team-members-module'
import GoogleReviewsModule from './components/google-reviews-module'
import LogosSlider from './components/logos-slider'
import FooterLogosSlider from './components/footer-logos-slider'
import TreamentsGrid from './components/treatments-grid'
import LogoAnimation from './components/logo-animation'
import HeadingColumnsSliderModule from './components/heading-columns-slider-module'
import ImageSliderModule from './components/image-slider-module'
import FAQs from './components/faqs'
import TreatmentNav from './components/treatment-nav'
import Map from './components/map';
import GlobalFooter from './components/global-footer'

const touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
const globalHeader = document.querySelector('[data-component="global-header"]')

domready(() => {

  const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }
  window.addEventListener('resize', appHeight)
  appHeight()

  if (touchDevice) {
    document.body.classList.add('touch')
  }

  history.scrollRestoration = 'manual'

  window.scrollTo(0, 0)

  document.queryAll('[data-component="leave-message-module"]').forEach(element => {
    new LeaveMessageModule({
      element
    })
  })

  document.queryAll('[data-component="global-header"]').forEach(element => {
    new GlobalHeader({
      element
    })
  })

  document.queryAll('.treatments-grid').forEach((element) => {
    new TreamentsGrid({
      element,
    })
  })

  document.queryAll('[data-component="page-hero-module"]').forEach(element => {
    new PageHeroModule({
      element
    })
  })

  document.queryAll('[data-component="treatments-module"]').forEach(element => {
    new TreatmentsModule({
      element
    })
  })

  document.queryAll('[data-component="emface-counters"]').forEach(element => {
    new EMFACECounters({
      element
    })
  })

  document.queryAll('nav[data-component="mobile"]').forEach(element => {
    new MobileNav({
      element
    })
  })

  document.queryAll('[data-component="videos-module"]').forEach(element => {
    new VideosModule({
      element
    })
  })

  document.queryAll('[data-component="logos-slider"]').forEach(element => {
    new LogosSlider({
      element
    })
  })

  document.queryAll('[data-component="footer-logos-slider"]').forEach(element => {
    new FooterLogosSlider({
      element
    })
  })

  document.queryAll('[data-component="treatment-nav"]').forEach(element => {
    new TreatmentNav({
      element
    })
  })

  document.queryAll('[data-component="image-slider-module"]').forEach(element => {
    new ImageSliderModule({
      element
    })
  })

  document.queryAll('[data-component="heading-columns-slider-module"]').forEach(element => {
    new HeadingColumnsSliderModule({
      element
    })
  })

  document.queryAll('[data-component="team-members-module"]').forEach(element => {
    new TeamMembersModule({
      element
    })
  })

  document.queryAll('[data-component="google-reviews-module"]').forEach(element => {
    new GoogleReviewsModule({
      element
    })
  })

  document.queryAll('[data-component="faqs"]').forEach(element => {
    new FAQs({
      element
    })
  })

  document.queryAll('[data-component="logo-animation"]').forEach(element => {
    new LogoAnimation({
      element
    })
  })

  document.queryAll('[data-component="map"]').forEach(element => {
    new Map()
  })

  document.queryAll('[data-component="global-footer"]').forEach(element => {
    new GlobalFooter({
      element
    })
  })

});
